// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

/*
 * Whether the `selectedInvoice` module's memo trio (`action` / `notes` /
 * `issue_credit`) was captured for the invoice whose credit memo is being
 * created.
 *
 * The invoice page's Refund dialogue populates the trio for ONE invoice and
 * records its id (`selectedInvoice/setMemoData`). Two guards ask this same
 * question and must never drift apart: the route-level `beforeEnter` on
 * `:id/create-credit-memo` (a fresh deep link, or a push from another route
 * record) and the create page's own `beforeRouteUpdate` (a params-only push
 * from invoice A's create page to invoice B's, which re-runs neither
 * `beforeEnter` nor `mounted()`). Both compare the route's `:id` (the invoice
 * UUID string the push already carries) against the recorded id with `===`.
 *
 * Pure and exported on its own, like `portal-only.js` and
 * `practice-standing.js` beside it, so the predicate is unit-testable without
 * the router or store closure — each guard hands in the module state it holds.
 */
export function memoDataBelongsTo(selectedInvoice, invoiceId) {
    return Boolean(selectedInvoice.action) && selectedInvoice.invoice_id === invoiceId;
}
